import React from 'react';

import TextField from '../Molecules/TextField';
import NumberField from '../Molecules/NumberField';
import SelectField from '../Molecules/SelectField';
import SingleNextButton from '../Atoms/SingleNextButton';
import YearMonthField from '../Atoms/YearMonthField';
import InvalidFeedback from '../Atoms/InvalidFeedback';
import Form from '../StepComponents/Form';
import StepShell from '../StepComponents/StepShell';
import { setApp, getApp, getAllStates} from '../../index';
import { nameRegex, currencyRegex } from '../../Utils/ValidationPatterns';
import { employmentStatuses } from '../../Utils/SelectOptions';

class StepEmploymentDetails extends React.Component {

    constructor(props) {
        super(props)
        var vwEmp = getApp('vwEmployee');
        this.state = {
            employment: '',
            checked: vwEmp,
            employer: ''
        }
    }

    employmentCond() {
        var employmentStatus = getApp('employmentStatus');
        this.setState({employment: employmentStatus});

        if(employmentStatus === "Self-Employed" || employmentStatus === "Employed") {
            setApp({employer: ""});
        }else{
            setApp({employer: employmentStatus});
        }
    }

    checkboxCheck(event) {
        this.setState({checked: !this.state.checked});
        setApp('vwEmployee', !this.state.checked);
    }

    render() {      
        let fields;
        var allStates = getAllStates();
        var existingEmployment = allStates.employmentStatus;
        var employment = existingEmployment ? existingEmployment: this.state.employment;

        if(employment === "Employed") {
            setApp('employer', '');
            setApp('position', '');
            fields = (
                <div>
                    <TextField name="employer" label="Employer" pattern={nameRegex} required={true}/>
                    <YearMonthField yearsName="yearsEmployer" yearsLabel="Years with Employer" monthsName="monthsEmployer" monthsLabel="Months with Employer" />
                    <TextField name="position" label="Position or Title" required={true} />
                    <div className="hug">
                        <NumberField name="annualIncome" prefix="$" pattern={currencyRegex} label="Gross Annual Income" required={true} /> 
                        <span className="helper-text">What you make before taxes.</span>
                    </div>

                    <div className="loanApp-checkbox hug">
                        <input type="checkbox" name="vwEmployee" value="yes" className="pull-left loanApp-form-control" defaultChecked={this.state.checked} onChange={this.checkboxCheck.bind(this)} />
                        <label htmlFor="vwEmployee">Check this box if you are a Vantage West Employee</label>                       
                        <InvalidFeedback feedback="invalid" />
                    </div>                    
                    <SingleNextButton nextBtnTxt="next" />  
                </div>
            );
        }else if(employment === "Self-Employed"){
            // setApp('employer', 'self');
            setApp('employer', '');
            setApp('position', '');
            fields = (
                <div>
                    <TextField name="employer" label="Company Name (optional)" pattern={nameRegex} required={false}/>           
                    <YearMonthField yearsName="yearsEmployer" yearsLabel="Years with Employer" monthsName="monthsEmployer" monthsLabel="Months with Employer" />
                    <TextField name="position" label="Position or Title" required={true} />
                    <div className="hug">
                        <NumberField name="annualIncome" prefix="$" pattern={currencyRegex} label="Gross Annual Income" required={true} /> 
                        <span className="helper-text">What you make before taxes.</span>
                    </div>
                    <SingleNextButton nextBtnTxt="next" />  
                </div>
            );

        }else if(employment === "Retired"){
            setApp('employer', 'retired');
            setApp('position', 'retired');
            fields = (
                <div>
                    <div className="hug">
                        <TextField name="incomeSource" label="Income Source" required={true}/>
                        <span className="helper-text">e.g. Social Security, Savings, Retirement Fund, etc.</span>
                    </div>
                    <div className="hug">
                        <NumberField name="annualIncome" prefix="$" pattern={currencyRegex} label="Gross Annual Income" required={true} /> 
                        <span className="helper-text">What you make before taxes.</span>
                    </div>
                    <SingleNextButton nextBtnTxt="next" />  
                </div>
            );
        }else if(employment === "Unemployed"){
            setApp('employer', 'unemployed');
            setApp('position', 'unemployed');
            fields = (
                <div>
                    <div className="hug">
                        <NumberField name="annualIncome" prefix="$" pattern={currencyRegex} label="Gross Annual Income" required={true} /> 
                        <span className="helper-text">What you make before taxes.</span>
                        <YearMonthField yearsName="yearsUnemployed" yearsLabel="Years Unemployed" monthsName="monthsUnemployed" monthsLabel="Months Unemployed" />
                    </div>
                    <SingleNextButton nextBtnTxt="next" />
                </div>
            );
        }else{
            fields = (
                <div></div>
            );
        }

        return (

            <StepShell stepID="StepEmploymentDetails"
                friendlyText="Got it. Next we need to know about where you work."
                requestText=""
                progress="47%"
                backLink="/loan-application/address"
                progressLabel="Work"               
            >
                <Form nextLink="/loan-application/co-applicant">
                    <div onChange={this.employmentCond.bind(this)}>
                        <SelectField options={employmentStatuses} required={true} name="employmentStatus" placeholder="Select One" label="Which option best describes your employment status?" labelType="bold" 
                            />
                    </div>          
                    {fields}                
                </Form>                         
            </StepShell>
        )
    }
}

export default StepEmploymentDetails;